module.exports = __webpack_public_path__ + "img/no-menu-list-items-image.1d601244.jpg";